import styled from 'styled-components';

export const CurrentConditionsObsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 93px;
    width: 100%;
`;
